/**
 * Platform Configuration
 * 
 * Central configuration for platform-level constants
 */

export const PLATFORM_WALLET_PUBKEY = import.meta.env.VITE_PLATFORM_WALLET || '8cm597KjGmwTSzadrcVCHVpqwzdRZy1BM2yUrDDEpJcB';

if (!PLATFORM_WALLET_PUBKEY) {
  console.warn('⚠️ PLATFORM_WALLET_PUBKEY not set. Set VITE_PLATFORM_WALLET in .env');
}

export const PLATFORM_CONFIG = {
  walletPubkey: PLATFORM_WALLET_PUBKEY,
  // Add other platform-level config here
} as const;

